export const premiumAutomationPlans = [
  { id: 'PremiumDV', wildcard: false },
  { id: 'PremiumSecure', wildcard: false },
  { id: 'PremiumWildcard', wildcard: true },
  { id: 'PremiumMultiWildcard', wildcard: true },
  { id: 'PremiumTrial', wildcard: false },
] as const;

export type PremiumAutomationPlan = typeof premiumAutomationPlans[number]['id'];
export const isPremiumPlan = (plan: string): plan is PremiumAutomationPlan => premiumAutomationPlans.some(p => p.id === plan);
export const isWildcardPlan = (plan: string) => premiumAutomationPlans.some(p => p.id === plan && p.wildcard);

export const isAutomationPlan = (plan: string | null): plan is 'Free' | 'Automation' | PremiumAutomationPlan =>
  plan === 'Free' || plan === 'Automation' || !!plan && isPremiumPlan(plan);
export const automationStartPath = (plan: string) => `/dashboard?install=choose&plan=${encodeURIComponent(isAutomationPlan(plan) ? plan : 'PremiumDV')}`;
export const automationSignupPath = (plan: string, locale: 'tr' | 'en') => `${locale === 'tr' ? '/tr' : ''}/register?returnTo=${encodeURIComponent(automationStartPath(plan))}`;
